import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import { types } from "./actionTypes";
import  { AxiosResponse } from "axios";
//medthods
import {
  postApi,
  getApi,
  deleteApi,
  putApi
} from "../../helpers/auth_helpers";

// workers
function* workerGetCatalogue({ filters, callback }: any) {
  let offset = filters?.offset ? filters?.offset : 0;
  let limit = filters?.limit ? filters?.limit : 10;
  let search = filters?.search || '';
  let name = filters?.name || '';
  let status = filters?.status || '';
  let sortBy = filters?.sortBy || 'createdAt';
  let sortOrder = filters?.sortOrder || 'desc';
  
  try {
    // Build URL with all parameters
    let url = process.env.REACT_APP_SERVERURL + "/catalouge/catalogues";
    url += "?offset=" + offset;
    url += "&limit=" + limit;
    if (search) url += "&search=" + encodeURIComponent(search);
    if (name) url += "&name=" + encodeURIComponent(name);
    if (status) url += "&status=" + encodeURIComponent(status);
    url += "&sortBy=" + sortBy;
    url += "&sortOrder=" + sortOrder;
    
    const response: AxiosResponse = yield call(getApi, url);
    callback(response);
    yield put({
      type: types.GET_CATALOGUE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
} 
function* workerCreateCatalogue({ payload, callback }: any) {
  try {
    const url: string = process.env.REACT_APP_SERVERURL + "/catalouge/createCatalogue";
    const response: AxiosResponse = yield call(postApi, url, payload);
    callback(response);
    yield put({
      type: types.CREATE_CATALOGUE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
    callback({ success: false });
  }
}
function* workerUpdateCatalogue({ payload, callback }: any) {
  try {
    const url: string = process.env.REACT_APP_SERVERURL + "/catalouge/update";
    const response: AxiosResponse = yield call(putApi, url, payload);
    callback(response);
    yield put({
      type: types.UPDATE_CATALOGUE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
    callback({ success: false });
  }
}
function* workerDeleteCatalogue({ id, callback }: any) {
    try {
      const url: string = process.env.REACT_APP_SERVERURL + `/catalouge/${id}/delete`;
      const response: AxiosResponse = yield call(deleteApi, url);
      callback(response);
      yield put({
        type: types.DELETE_CATALOGUE_SUCCESS,
        payload: response,
      });
    } catch (e) {
      console.log(e);
    }
}
  //products in catalogue
function* workerGetProductsByCatalogueId({ filters, catalogueId,callback }: any) {
  let offset = filters?.offset ? filters?.offset : 0;
  let limit = filters?.limit ? filters?.limit : 10;
  const search = filters?.search;
  const sortBy = filters?.sortBy || "name";
  const sortOrder = filters?.sortOrder || "asc";
  const usePublic = filters?.usePublicCatalogueEndpoint === true;
  const typeTagIds: string[] = Array.isArray(filters?.typeTagIds) ? filters.typeTagIds : [];
  try {
    let url: string;
    if (usePublic) {
      url =
        process.env.REACT_APP_SERVERURL +
        `/catalouge/public/${catalogueId}/products?offset=` +
        offset +
        "&limit=" +
        limit +
        "&sortBy=" +
        encodeURIComponent(sortBy) +
        "&sortOrder=" +
        encodeURIComponent(sortOrder);
      if (search) {
        url += "&search=" + encodeURIComponent(search);
      }
    } else {
      url =
        process.env.REACT_APP_SERVERURL +
        `/catalouge/${catalogueId}/products?offset=` +
        offset +
        "&limit=" +
        limit;
      if (search) {
        url += "&search=" + encodeURIComponent(search);
      }
      url +=
        "&sortBy=" +
        encodeURIComponent(sortBy) +
        "&sortOrder=" +
        encodeURIComponent(sortOrder);
    }
    if (typeTagIds.length) {
      url += "&typeTagIds=" + encodeURIComponent(typeTagIds.join(","));
    }
    const response: AxiosResponse = yield call(getApi, url);
    callback(response);
    yield put({
      type: types.GET_ALL_PRODUCT_WITH_CATALOGUE_ID_SUCCESS,
      payload: response,
    });
  } catch (e) {
    if (typeof callback === "function") callback({ success: false, code: "NETWORK_UNAVAILABLE" });
  }
} 
function* workerAddProductsIntoCatalogue({ payload,catalogueId, callback }: any) {
  try {
    const url: string = process.env.REACT_APP_SERVERURL + `/catalouge/${catalogueId}/addProducts`;
    const response: AxiosResponse = yield call(postApi, url, payload);
    callback(response);
    yield put({
      type: types.CREATE_CATALOGUE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
    if (typeof callback === "function") {
      callback({
        success: false,
        code: "NETWORK_UNAVAILABLE",
        message: "Could not confirm whether products were added. Refresh the catalogue before trying again.",
        data: null,
      });
    }
  }
}
export function* workerDeleteProductFromCatalogue({ payload,catalogueId, callback }: any) {
    try {
      const url: string = process.env.REACT_APP_SERVERURL + `/catalouge/${catalogueId}/removeProducts`;
      const response: AxiosResponse = yield call(postApi, url,payload);
      if (typeof callback === "function") callback(response || { success: false });
    } catch (e) {
      if (typeof callback === "function") callback({ success: false, code: "NETWORK_UNAVAILABLE" });
    }
  }
// watchers
export function* watchGetCatalogue() {
  yield takeEvery(types.GET_CATALOGUE, workerGetCatalogue);
}
export function* watchCreateCatalogue() {
  yield takeEvery(types.CREATE_CATALOGUE, workerCreateCatalogue);
}
export function* watchUpdateCatalogue() {
  yield takeEvery(types.UPDATE_CATALOGUE, workerUpdateCatalogue);
}
export function* watchDeleteCatalogue() {
    yield takeEvery(types.DELETE_CATALOGUE, workerDeleteCatalogue);
}
//products with catalogue
  export function* watchGetProductsByCatalogueId() {
  yield takeEvery(types.GET_ALL_PRODUCT_WITH_CATALOGUE_ID, workerGetProductsByCatalogueId);
}
export function* watchAddProductsIntoCatalogue() {
  yield takeEvery(types.ADD_PRODUCT_WITH_CATALOGUE_ID, workerAddProductsIntoCatalogue);
}
export function* watchDeleteProductFromCatalogue() {
    yield takeEvery(types.REMOVE_PRODUCT_FROM_CATALOGUE, workerDeleteProductFromCatalogue);
  }

function* CatalogueSaga() {
  yield all([fork(watchGetCatalogue)]);
  yield all([fork(watchCreateCatalogue)]);
  yield all([fork(watchUpdateCatalogue)]);
  yield all([fork(watchDeleteCatalogue)]);
  yield all([fork(watchGetProductsByCatalogueId)]);
  yield all([fork(watchAddProductsIntoCatalogue)]);
  yield all([fork(watchDeleteProductFromCatalogue)]);
}
export default CatalogueSaga;
